import React from 'react';
import IntroPisoSpcPremium from '../components/sections/Piso-Spc-Premium/IntroPisoSpcPremium';
import TituloPisoSpcPremium from '../components/sections/Piso-Spc-Premium/TituloSpcPremium';
import CaracteristicasGeneralesSpcPremium from '../components/sections/Piso-Spc-Premium/CaracteristicasGeneralesSpcPremium';
import CaracteristicaUnoSpcPremium from '../components/sections/Piso-Spc-Premium/CaracteristicaUnoSpcPremium';
import VideoSpcPremium from '../components/sections/Piso-Spc-Premium/VideoSpcPremium';
import CatalogoProductoSpcPremium from '../components/sections/Piso-Spc-Premium/CatalogoProductoSpcPremium';
import ReversoPisoSpcPremium from '../components/sections/Piso-Spc-Premium/ReversoPisoSpcPremium';
import ReversoPisoPremiumB from '../components/sections/Piso-Spc-Premium/ReversoPisoPremiumB';
import FormularioContactoSpcPremium from '../components/sections/Piso-Spc-Premium/FormularioContactoSpcPremium';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const PisosSpcPages = () => {
  return (
    <div>
      <Header />
       {/* Sección introductoria del piso vinílico LVT */}
       <TituloPisoSpcPremium />

       <IntroPisoSpcPremium />

       <CaracteristicasGeneralesSpcPremium />

       <CaracteristicaUnoSpcPremium /> 

       <VideoSpcPremium />

       <CatalogoProductoSpcPremium />

       {/* Sección de reverso del piso SPC Premium */}
       {/* <ReversoPisoSpcPremium /> */}

       <ReversoPisoPremiumB />

       <FormularioContactoSpcPremium />

      <Footer />
    </div>
  );
};

export default PisosSpcPages;